import { render, staticRenderFns } from "./IngresosAcumulados.vue?vue&type=template&id=1beb6621&scoped=true"
import script from "./IngresosAcumulados.vue?vue&type=script&lang=js"
export * from "./IngresosAcumulados.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./IngresosAcumulados.vue?vue&type=style&index=1&id=1beb6621&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beb6621",
  null
  
)

export default component.exports